import Vue from 'vue';
import moment from 'moment';
import cookie from '../../../cookie/cookie';
import { toYuan } from '../../../utils/unit-conversion';
import eventBus from '../../../utils/fresh-table';
export default Vue.extend({
    name: 'fundTerminalOrder',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        waitAmout: function () {
            var _a = this.data, planAmount = _a.planAmount, paidAmount = _a.paidAmount;
            if (!isNaN(Number.parseFloat(planAmount)) &&
                !isNaN(Number.parseFloat(paidAmount))) {
                return toYuan(planAmount - paidAmount);
            }
            return 0;
        },
    },
    data: function () {
        return {
            usernameZh: '',
            ruleForm: {},
            rules: {
                rentDay: [
                    { required: true, message: '请选择收款日期', trigger: 'change' },
                ],
            },
            pickerOption: {
                disabledDate: function (time) {
                    var currentTime = new Date();
                    var tomorrow = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate()).getTime() +
                        1 * 24 * 60 * 60 * 1000;
                    return new Date(time).getTime() >= tomorrow;
                },
            },
        };
    },
    created: function () {
        this.getUserName();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        cancle: function () {
            this.$emit('cancle-dialog');
        },
        getParams: function () {
            var planCode = this.data.planCode;
            var rentDay = this.ruleForm.rentDay;
            return {
                operator: this.usernameZh,
                planCode: planCode,
                rentDay: moment(rentDay).format('YYYY-MM-DD'),
            };
        },
        submitForm: function () {
            var _this = this;
            this.$refs['ruleForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
                var data = _this.getParams();
                _this.$request({
                    url: '/proxy/fund-api/capital/repay/plan/supplement',
                    method: 'post',
                    data: data,
                }).then(function (res) {
                    if (!res || res.errorCode !== 0) {
                        return;
                    }
                    _this.$message({
                        type: 'success',
                        message: '补录成功!',
                    });
                    eventBus.$emit('freshTable');
                    setTimeout(function () {
                        _this.cancle();
                    }, 1000);
                });
            });
        },
    },
});
